import React, { memo } from 'react'

import OverviewNavPanel from '../../../components/overview/OverviewNavPanel'

const OverviewNavPanelWrapper = (props) => {
  return <OverviewNavPanel {...props} />
}

export default memo(OverviewNavPanelWrapper)
